import React from 'react';
import { Card, Row, Col } from 'antd';
import moment from 'moment';
import { useSelector } from 'react-redux';
import './dashboard.css';

const SiteInfoCard = () => {
  const { inspectionTime, stationSummary = {} } = useSelector(
    state => state.analytics || {}
  );
  const siteInfo = inspectionTime?.stationInfo || {};
  const summary = stationSummary[inspectionTime?.stationId] || {};
  const devices = summary.devices || 0;
  const onlineDevices = summary.onlineDevices || 0;

  return (
    <Card className="siteInfoCard">
      <h3>{siteInfo.stationName}</h3>
      <p className="address">{siteInfo.addr}</p>
      <div className="infoBox">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <label>Owner</label>
            <div>{siteInfo.userName}</div>
          </Col>
          <Col span={12}>
            <label>Commercial Operation Date</label>
            <div>
              {siteInfo.commercialOperationDate
                ? moment(siteInfo.commercialOperationDate).format('YYYY-MM-DD')
                : ''}
            </div>
          </Col>
          <Col span={12}>
            <label>Capacity</label>
            <div>{siteInfo.capacity} kWp</div>
          </Col>
          <Col span={12}>
            <label>Devices</label>
            <div>
              {onlineDevices}/{devices} Online
            </div>
          </Col>
          <Col span={12}>
            <label>Initial Performance Ratio</label>
            <div>{siteInfo.initialPerformanceRatio}%</div>
          </Col>
          <Col span={12}>
            <label>Decay Factor</label>
            <div>{siteInfo.decayFactor}%</div>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default SiteInfoCard;
